import baseUrl from './baseUrl'

export default {
  action: {
    permissionUserView: 'view-users',
    permissionUserAdd: 'add-users',
    permissionUserEdit: 'edit-users',
    permissionUserDelete: 'delete-users',
    permissionUserLogin: 'login',
    permissionClientView: 'view-client',
    permissionClientAdd: 'add-client',
    permissionClientEdit: 'edit-client',
    permissionClientDelete: 'delete-client',
    permissionLogin: 'login',
    permissionSettings: 'settings',
    permissionTranslationView: 'view-translation',
    permissionTranslationAdd: 'add-translation',
    permissionTranslationEdit: 'edit-translation',
    permissionTranslationDelete: 'delete-translation',
    permissionRoleView: 'view-roles',
    permissionRoleAdd: 'add-roles',
    permissionRoleEdit: 'edit-roles',
    permissionRoleDelete: 'delete-roles',
    permissionCommunicationLogDetails: 'view-communicationlogdetails',
    permissionEmailTemplateView: 'view-email-template',
    permissionEmailTemplateAdd: 'add-email-template',
    permissionEmailTemplateEdit: 'edit-email-template',
    permissionEmailTemplateDelete: 'delete-email-template',
    permissionSMSTemplateView: 'view-sms-template',
    permissionSMSTemplateAdd: 'add-sms-template',
    permissionSMSTemplateEdit: 'edit-sms-template',
    permissionSMSTemplateDelete: 'delete-sms-template',
    permissionCommunicationLogsList: 'view-communication-logs',
    permissionApiTokenAdd: 'add-api-tokens',
    permissionApiTokenEdit: 'edit-api-tokens',
    permissionApiTokenDelete: 'delete-api-tokens',
    permissionApiTokenList: 'view-api-tokens',
    permissionApiTokenRevoke: 'revoke-api-tokens',
    permissionFailedSmsResponseLogsList: 'view-sms-response-logs',
    permissionLetterTemplateAdd: 'add-letter-template',
    permissionLetterTemplateEdit: 'edit-letter-template',
    permissionLetterTemplateDelete: 'delete-letter-template',
    permissionLettersList: 'view-letter-template',
    permissionEventLogsList: 'view-event-logs',
    permissionProcessAdd: 'add-process',
    permissionProcessEdit: 'edit-process',
    permissionProcessDisable: 'disable-process',
    permissionProcessList: 'view-process',
    permissionDebtorView: 'view-debtor',
    permissionDebtorAdd: 'add-debtor',
    permissionDebtorEdit: 'edit-debtor',
    permissionDebtorDelete: 'delete-debtor',
    permissionDebtCaseAdd: 'add-debt-case',
    permissionDebtCaseEdit: 'edit-debt-case',
    permissionDebtCaseView: 'view-debt-case',
    permissionDebtCaseDelete: 'delete-debt-case',
    permissionGenerateAgreementPlan: 'generate-agreement-plan',
    permissionCaseProcessChange: 'case-process-change-permission',
    permissionCancelAgreementPlan: 'cancel-agreement-plan',
    permissionOrdersList: 'view-orders',
    permissionAddCaseGroup: 'add-debt-case-group',
    permissionListCaseGroup: 'view-debt-case-group',
    permissionDeleteCaseGroup: 'delete-debt-case-group',
    permissionEditCaseGroup: 'edit-debt-case-group',
    permissionFileCategoryAdd: 'add-file-category',
    permissionFileCategoryEdit: 'edit-file-category',
    permissionFileCategoryView: 'view-file-category',
    permissionFileCategoryDelete: 'delete-file-category',
    permissionUserSettings: 'user-settings',
    permissionFilterListView: 'view-filter-list',
    permissionFilterListAdd: 'add-filter-list',
    permissionFilterListDelete: 'delete-filter-list',
    permissionFilterListEdit: 'edit-filter-list',
    permissionEditStatements: 'edit-statements',
    permissionDeleteDebtCaseFile: 'delete-debt-case-file',
    permissionStatementGroupAdd: 'add-statement-group',
    permissionStatementGroupEdit: 'edit-statement-group',
    permissionStatementGroupView: 'view-statement-group',
    permissionStatementGroupDelete: 'delete-statement-group',
    permissionEditCustomVar: 'edit-custom-variables',
    permissionAddCustomVar: 'add-custom-variables',
    permissionViewCustomVar: 'view-custom-variables',
    permissionDeleteCustomVar: 'delete-custom-variables',
    permissionContactView: 'view-contact',
    permissionContactAdd: 'add-contact',
    permissionContactEdit: 'edit-contact',
    permissionContactDelete: 'delete-contact',
    permissionAssignPartner: 'assign-partner',
    permissionStuckCases: 'stuck-cases-permission',
    permissionDeleteDebtCaseNote: 'delete-log-permission',
    permissionPartnerView: 'view-partner',
    permissionPartnerAdd: 'add-partner',
    permissionPartnerEdit: 'edit-partner',
    permissionPartnerDelete: 'delete-partner',
    permissionRkiRegistration: 'allow-rki-registration',
    permissionEditSubscription: 'edit-subscription-entry',
    permissionManualRkiRegistration: 'manual-rki-registration',
    permissionCaseTermination: 'case-termination-permission',
  },
  resource: {
    user: 'App\\Models\\User\\User',
    client: 'App\\Models\\Client\\Client',
    translation: 'App\\Models\\Translation\\Translation',
    role: 'App\\Models\\Permission\\DefaultPermission',
    apiToken: 'App\\Models\\ApiToken',
    process: 'App\\Models\\Process\\Process',
    debtor: 'App\\Models\\Debtor\\Debtor',
    debtCase: 'App\\Models\\Debt\\DebtCase',
    caseGroups: 'App\\Models\\Debt\\DebtCaseGroups',
    fileCategories: 'App\\Models\\Settings\\FileCategories',
    filterLists: 'App\\Models\\Data\\FilterList',
    statementGroups: 'App\\Models\\Debt\\StatementGroup',
    customVariables: 'App\\Models\\CustomVariable\\CustomVariable',
    contact: 'App\\Models\\Contact\\Contact',
    partner: 'App\\Models\\Partners\\Partner',
  },

  // BASEURL
  paymentsBaseUrl: baseUrl.paymentsBaseUrl,
  baseUrl: baseUrl.ApiBaseUrl,
  baseUrlV2: baseUrl.ApiBaseUrlV2,
  serverBaseUrl: baseUrl.serverBaseUrl,
  communicationBaseUrlV1: baseUrl.communicationBaseUrlV1,
  communicationBaseUrl: baseUrl.communicationBaseUrl,
  lettersBaseUrl: baseUrl.lettersBaseUrl,
  paymentsBaseUrlV2: baseUrl.paymentsBaseUrlV2,
}
